// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ClockGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width={36} height={36} rx={8} fill="url(#ClockGradient_tsx__a)" />
		<path transform="translate(6.001 6)" fill="url(#ClockGradient_tsx__b)" d="M0 0h24v24H0z" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.831 21.42a.5.5 0 0 0 .067-.703l-2.396-2.895V12.96a.5.5 0 1 0-1 0V18a.5.5 0 0 0 .114.32l2.511 3.033a.499.499 0 0 0 .704.067Zm-2.83 5.455c-4.894 0-8.875-3.98-8.875-8.873 0-4.895 3.981-8.877 8.876-8.877 4.893 0 8.874 3.982 8.874 8.877 0 4.893-3.981 8.873-8.875 8.873Z"
			fill="#fff"
			fillOpacity={0.8}
		/>
		<defs>
			<linearGradient id="ClockGradient_tsx__a" x1={0} y1={0} x2={36} y2={36} gradientUnits="userSpaceOnUse">
				<stop stopColor="#75B2F0" />
				<stop offset={1} stopColor="#B275F0" />
			</linearGradient>
			<linearGradient id="ClockGradient_tsx__b" x1={0} y1={0} x2={24} y2={24} gradientUnits="userSpaceOnUse">
				<stop stopColor="#75B2F0" />
				<stop offset={1} stopColor="#B275F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default ClockGradient;
